import React, { useEffect } from 'react';

import { useRequiredContext } from './common/hooks-util';
import { AuthContext } from './contexts/auth-context';
import { useCompany } from './contexts/company-context';
import { OpenAPI as TellUsApiOptions } from './generated/tellus';

// Init TellUs API client.
TellUsApiOptions.BASE = process.env.REACT_APP_API_URI ?? '';

export const TellUsApiProvider: React.FC = ({ children }) => {
  const { getAccessToken } = useRequiredContext(AuthContext);
  const { activeCompanyKey } = useCompany();

  useEffect(() => {
    TellUsApiOptions.TOKEN = async () => (await getAccessToken()) ?? '';
    TellUsApiOptions.HEADERS = async () => {
      const headers: Record<string, string> = {};

      if (activeCompanyKey) {
        headers['X-Active-Company-Key'] = activeCompanyKey;
      }

      return headers;
    };
  }, [activeCompanyKey, getAccessToken]);

  return <>{children}</>;
};
